/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOrderPackageCustomerOrderDeliverySchedules(orderPackageID) {
  const response = await $.soap({
    body: {
      GetOrderPackageCustomerOrderDeliverySchedules: {
        $xmlns: 'http://dla.mil/ems/bpm/order_package',
        OrderPackageID: orderPackageID
      }
    },
    blueprintArrays: ['GetOrderPackageCustomerOrderDeliverySchedulesResponse.tuple'],
    blueprint: {
      customerOrderDeliverySchedules: [
        '$..GetOrderPackageCustomerOrderDeliverySchedulesResponse.tuple',
        {
          id: '$.old.CustomerOrderDeliverySchedule.DeliveryScheduleID',
          orderLineItemID: '$.old.CustomerOrderDeliverySchedule.OrderLineItemID',
          lineNumber: '$.old.CustomerOrderDeliverySchedule.LineNumber',
          clin: '$.old.CustomerOrderDeliverySchedule.CLIN',
          price: '$.old.CustomerOrderDeliverySchedule.Price',
          equipmentName: '$.old.CustomerOrderDeliverySchedule.EquipmentName',
          volumeBand: '$.old.CustomerOrderDeliverySchedule.VolumeBand',
          model: '$.old.CustomerOrderDeliverySchedule.Model',
          laserPrinterTonerCartridgeType: '$.old.CustomerOrderDeliverySchedule.LaserPrinterTonerCartridgeType',
          description: '$.old.CustomerOrderDeliverySchedule.Description',
          customDescription: '$.old.CustomerOrderDeliverySchedule.CustomDescription',
          paperCapacityHandling: '$.old.CustomerOrderDeliverySchedule.PaperCapacityHandling',
          configurationAndPricing: '$.old.CustomerOrderDeliverySchedule.ConfigurationAndPricing',
          isColor: '$.old.CustomerOrderDeliverySchedule.IsColor',
          isNipr: '$.old.CustomerOrderDeliverySchedule.IsNIPR',
          optionalAccessories: '$.old.CustomerOrderDeliverySchedule.OptionalAccessories',
          additionalServiceId: '$.old.CustomerOrderDeliverySchedule.AdditionalServiceID',
          additionalServiceCLIN: '$.old.CustomerOrderDeliverySchedule.AdditionalServiceCLIN',
          additionalService: '$.old.CustomerOrderDeliverySchedule.AdditionalService',
          additionalAccessoryId: '$.old.CustomerOrderDeliverySchedule.AdditionalAccessoryID',
          additionalAccessoryCLIN: '$.old.CustomerOrderDeliverySchedule.AdditionalAccessoryCLIN',
          additionalAccessory: '$.old.CustomerOrderDeliverySchedule.AdditionalAccessory',
          mfdAdditionalService: '$.old.CustomerOrderDeliverySchedule.MFDAdditionalService',
          deliveryPOCFirstName: '$.old.CustomerOrderDeliverySchedule.DeliveryPOCFirstName',
          deliveryPOCLastName: '$.old.CustomerOrderDeliverySchedule.DeliveryPOCLastName',
          deliveryPOCEmail: '$.old.CustomerOrderDeliverySchedule.DeliveryPOCEmail',
          deliveryPOCPhone: '$.old.CustomerOrderDeliverySchedule.DeliveryPOCPhone',
          itPOCFirstName: '$.old.CustomerOrderDeliverySchedule.ITPOCFirstName',
          itPOCLastName: '$.old.CustomerOrderDeliverySchedule.ITPOCLastName',
          itPOCEmail: '$.old.CustomerOrderDeliverySchedule.ITPOCEmail',
          itPOCPhone: '$.old.CustomerOrderDeliverySchedule.ITPOCPhone',
          finPOCFirstName: '$.old.CustomerOrderDeliverySchedule.FinPOCFirstName',
          finPOCLastName: '$.old.CustomerOrderDeliverySchedule.FinPOCLastName',
          finPOCEmail: '$.old.CustomerOrderDeliverySchedule.FinPOCEmail',
          finPOCPhone: '$.old.CustomerOrderDeliverySchedule.FinPOCPhone',
          termingSerialNumber: '$.old.CustomerOrderDeliverySchedule.TermingSerialNumber',
          isReplacement: '$.old.CustomerOrderDeliverySchedule.IsReplacement',
          network: '$.old.CustomerOrderDeliverySchedule.Network',
          trainingType: '$.old.CustomerOrderDeliverySchedule.TrainingType',
          trainingTypeId: '$.old.CustomerOrderDeliverySchedule.TrainingTypeID',
          address: {
            addressId: '$.old.CustomerOrderDeliverySchedule.AddressID',
            addressLine1: '$.old.CustomerOrderDeliverySchedule.Address1',
            addressLine2: '$.old.CustomerOrderDeliverySchedule.Address2',
            buildingFloorNumber: '$.old.CustomerOrderDeliverySchedule.BuildingFloorNumber',
            floorNumber: '$.old.CustomerOrderDeliverySchedule.FloorNumber',
            roomNumber: '$..old.CustomerOrderDeliverySchedule.RoomNumber',
            poleNumber: '$..old.CustomerOrderDeliverySchedule.PoleNumber',
            suite: '$..old.CustomerOrderDeliverySchedule.Suite',
            roomPoleNumber: '$.old.CustomerOrderDeliverySchedule.RoomPoleNumber',
            city: '$.old.CustomerOrderDeliverySchedule.City',
            zip: '$.old.CustomerOrderDeliverySchedule.Zip',
            regionId: '$.old.CustomerOrderDeliverySchedule.RegionID',
            regionCode: '$.old.CustomerOrderDeliverySchedule.RegionCode',
            regionName: '$.old.CustomerOrderDeliverySchedule.RegionName'
          },
          commandName: '$.old.CustomerOrderDeliverySchedule.CommandName',
          branchName: '$.old.CustomerOrderDeliverySchedule.BranchName',
          commandEchelon: '$.old.CustomerOrderDeliverySchedule.CommandEchelon',
          trackerNumber: '$.old.CustomerOrderDeliverySchedule.TrackerNumber',
          note: '$.old.CustomerOrderDeliverySchedule.Note'
        }
      ]
    }
  });

  cleanUpResponse(response);

  _.each(response.customerOrderDeliverySchedules, (deliverySchedule) => {
    deliverySchedule.deliveryPOCName = deliverySchedule.deliveryPOCFirstName
      ? `${deliverySchedule.deliveryPOCFirstName} ${deliverySchedule.deliveryPOCLastName}`
      : null;
    deliverySchedule.itPOCName = deliverySchedule.itPOCFirstName
      ? `${deliverySchedule.itPOCFirstName} ${deliverySchedule.itPOCLastName}`
      : null;
    deliverySchedule.finPOCName = deliverySchedule.finPOCFirstName
      ? `${deliverySchedule.finPOCFirstName} ${deliverySchedule.finPOCLastName}`
      : null;
  });

  return response.customerOrderDeliverySchedules;
}
